import { Component } from '@angular/core';
import { Location } from '@angular/common';
import appSettings from '../../../assets/settings/system.settings.json'


@Component({
    selector: 'download-shared',
    templateUrl: './download.html',
})
export class DownloadComponent {

    constructor(private _location: Location) {
        this.downloadFile();

    }
    downloadFile() {

        var fileApi = `${appSettings.apiSettings.apiUrl}${appSettings.apiPath.master}/api/SchedulerTask/GetUserGuide`

        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', fileApi);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this._location.back();
    }

}

